import { createContext, FC, useContext } from 'react';
import { AxiosInstance } from 'axios';

export interface MicrositeApiContext {
  baseAxios: AxiosInstance;
}

const Context = createContext<MicrositeApiContext | undefined>(undefined);

export const MicrositeApiContextProvider: FC<{ value: MicrositeApiContext }> =
  ({ value, children }) => (
    <Context.Provider value={value}>{children}</Context.Provider>
  );

export const useMicrositeApiContext = () => {
  const ctx = useContext(Context);
  if (!ctx) {
    throw new Error('ApiContext not provided');
  }

  return ctx;
};
